import { createSelector } from "reselect";
import getProject from "./get_project";

const getProjectSettings = createSelector([
  getProject
], (project) => project?.settings);

export default getProjectSettings;